import {
    PROMOTION_CREATE,
    PROMOTION_FETCH,
    PROMOTION_FETCH_BY_ID,
    PROMOTION_UPDATE
} from '../actions/types';

const INITIAL_STATE = { 
    loading: false,
    promotions: null,
    promotion: null
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
        case PROMOTION_CREATE:
        case PROMOTION_UPDATE:
            return { ...state, loading: action.payload }
        case PROMOTION_FETCH:
            return { ...state, promotions: action.payload }
        case PROMOTION_FETCH_BY_ID:
            return { ...state, promotion: action.payload }
        default:
            return state
    }
}